var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{style:({ opacity: _vm.opacity }),attrs:{"id":_vm.id}},[_c(_vm.screenItem.itemType,{tag:"component",attrs:{"event":_vm.screenItem,"opacity":_vm.opacity,"selected":_vm.selected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }